'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { makeLocalizedPathname } from '../../personly-libs-pathnames/src/index.js';
const useLocalizedPathname = locales => {
  const $ = _c(2);
  let t0;
  if ($[0] !== locales) {
    t0 = makeLocalizedPathname(locales);
    $[0] = locales;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const result = t0;
  return result;
};
export default useLocalizedPathname;